import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css'
import { mainContext } from '../../../MainContext';


function ContainerProfile() {
  const { t } = useTranslation();


  useEffect(() => {
  }, [])


  return (
    <div className={`${styles.wrap} margin-horizontal-auto`}>
      <h2 className={styles.title}>Profile</h2>
      <img src="./img/profile/nao.jpg" className={styles.profileImg} alt="" />
      <h3 className={styles.name}>{t('common.name')}</h3>

      <div className={styles.label}>
        <div>
          <p className={styles.labelTxt}>
            {t('profile.label').split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        </div>
      </div>

      <p className={styles.discription}>
        {t('profile.content').split('\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </p>
    </div>
  );
}

export default ContainerProfile;